import { Component, inject } from '@angular/core';
import {
  ModalController, IonButton, IonButtons, IonIcon,
  IonHeader, IonToolbar, IonTitle, IonContent
} from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-notification-permission-modal',
  standalone: true,
  imports: [
    IonButton, IonButtons, IonIcon,
    IonHeader, IonToolbar, IonTitle, IonContent,
    TranslocoPipe,
  ],
  template: `
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ 'notificationPermission.title' | transloco }}</ion-title>
        <ion-buttons slot="end">
          <ion-button fill="clear" color="medium" (click)="skip()" [attr.aria-label]="'general.close' | transloco">
            <ion-icon slot="icon-only" name="close-circle-outline" size="large"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
      <div class="modal-content">
        <p>{{ 'notificationPermission.message' | transloco }}</p>

        <div class="notification-footer">
          <ion-button fill="outline" color="medium" (click)="skip()">{{ 'notificationPermission.maybeLater' | transloco }}</ion-button>
          <ion-button color="primary" (click)="enableAlerts()">{{ 'notificationPermission.enableAlerts' | transloco }}</ion-button>
        </div>
      </div>
    </ion-content>
  `,
  styles: [`
    .notification-footer {
      display: flex;
      justify-content: space-between;
      margin-top: 2em;
      gap: 0.5em;
    }
      
    .modal-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 100%;
      padding: 0 20px;
    }

  `]
})
export class NotificationPermissionModalComponent {
  private modalCtrl = inject(ModalController);

  async enableAlerts() {
    let granted = false;
    if (Capacitor.isNativePlatform()) {
      try {
        const OneSignalCap = await import('@onesignal/capacitor-plugin');
        granted = await OneSignalCap.default.Notifications.requestPermission(true);
      } catch (error) {
        console.error('OneSignal permission request failed:', error);
      }
    } else {
      try {
        const permission = await Notification.requestPermission();
        granted = permission === 'granted';
      } catch {}
    }
    this.modalCtrl.dismiss({ granted });
  }

  skip() {
    this.modalCtrl.dismiss({ granted: false });
  }
}
